import { Box, Spinner, SpinnerProps } from '@amzn/awsui-components-core';
import React from 'react';
import '../../resources/styles/scss/components/common/loading.scss';

interface Props {
  size?: SpinnerProps.Size;
}

const LoadingPage: React.FC<Props> = ({ size = 'large' }) => {
  return (
    <div className="loading-spinner">
      <Spinner size={size} />
      <Box display="inline" fontSize="heading-l">
        Loading...
      </Box>
    </div>
  );
};

export default LoadingPage;
